<template>
  <el-menu :default-active="defaultActive">
    <el-menu-item
      v-for="(item, index) in menuItems"
      :key="item.title"
      :index="item.title"
      :disabled="item.disabled"
      @click="$emit('update', item)"
    >
      <div class="menu-item-wrapper">
        <div v-if="item.isCompleted" class="badge-success">
          <icon class="icon" glyph="check-mark" size="12" />
        </div>
        <el-badge v-else type="info" :value="index + 1" />

        <span class="title">
          {{ item.title }}
        </span>
      </div>
    </el-menu-item>
  </el-menu>
</template>
<script>
export default {
  name: 'GameCampaignContentNav',

  props: {
    menuItems: {
      type: Array,
      required: true
    },
    defaultActive: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
.el-menu {
  border-right: 0;
  padding: 8px 8px 8px 8px;
  background: #f8fafc;
  border-radius: 4px;
}

.el-menu-item {
  font-weight: 600;
  font-size: 12px;
  color: #4b515f;
  min-width: inherit;
}

>>> .el-menu--inline {
  background: #f8fafc;
  border-radius: 4px;
}

>>> .el-menu-item.is-active {
  background: #fff;
}

>>> .el-menu-item.is-disabled {
  opacity: 0.8;
}

span.title {
  font-weight: 600;
  font-size: 14px;
  color: #1d87c8;
}

>>> .el-submenu.is-active {
  color: #0087ce;
}

>>> .el-badge__content--info {
  background-color: #fff;
  color: #4b515f;
  border-color: #ebeef5;
  box-shadow: 0px 1px 3px 0px #4b515f26;
}
.badge-success {
  background-color: #fff;
  color: #1d9513;
  border: 1px solid #1d9513;
  border-radius: 100%;
  height: 18px;
  width: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.menu-item-wrapper {
  display: flex;
  gap: 12px;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-campaigns/GameCampaignContentNav.vue